export const EmployeeRoles = [
  { value: 1, roleName: 'Master manager' },
  { value: 2, roleName: 'Manager' },
  { value: 3, roleName: 'Cashier' },
  { value: 4, roleName: 'Backuser' },
];

export const EmployeeRoleKeys = {
  MASTER_MANAGER: 1,
  MANAGER: 2,
  CASHIER: 3,
  BACKUSER: 4,
};
